import React from 'react';
import { Chip } from '@mui/material';

// shared bits for the wallet screens — one source for the Prepaid/Postpaid rendering
export const WALLET_TYPE_OPTIONS = [
    { value: 'Prepaid', label: 'Prepaid' },
    { value: 'Postpaid', label: 'Postpaid' },
];

export const WalletTypeChip = ({ type }) => (
    <Chip size="small" variant="outlined" label={type || 'None'}
        color={type === 'Prepaid' ? 'primary' : type === 'Postpaid' ? 'secondary' : 'default'} />
);
